import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from '../service/local-storage.service';
import { MainService } from '../service/main.service';
import { ToasterServiceService } from '../service/toaster.service';
import { ApiUrls } from '../apiRouts';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  ContactUsForm: any = FormGroup;
  submitted = false;
  userId: any;

  constructor(
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    private toasterService: ToasterServiceService,
    private router: Router,
  ) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.ContactUsForm = this.fb.group({
      person_name: ['', [Validators.required]],
      contact_number: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(7)]],
      description: ['', [Validators.required]],
    })
  }

  get f() {
    return this.ContactUsForm.controls;
  }

  contactAdd() {
    this.submitted = true;
    if (this.ContactUsForm.valid) {
      let data = {
        contact_us_id: 0,
        person_name: this.ContactUsForm.value.person_name,
        contact_number: this.ContactUsForm.value.contact_number.toString(),
        description: this.ContactUsForm.value.description,
        Action: 'INSERT',
      };
      this.mainService.postApi(ApiUrls.sendContactUs, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.ContactUsForm.reset();
          this.submitted = false;
          if (this.userId == "" || this.userId === null || this.userId === undefined) {
            this.toasterService.toastSuccess(res.response);
            this.router.navigate(["/auth/login"]);
          } else {
            this.router.navigate(["/dashboard"]);
          }
        }
        else {
          this.submitted = true
        }
      })
    }
  }
}
